module.exports = __webpack_public_path__ + "static/media/mTakano.0b642a7d.jpeg";